var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 12.7423V17.1616M16 21.5808H16.0115M14.036 7.06364L4.30783 22.6856C4.10726 23.0197 4.00113 23.3985 4.00001 23.7843C3.99889 24.1702 4.10281 24.5495 4.30143 24.8847C4.50005 25.2199 4.78646 25.4992 5.13215 25.6949C5.47784 25.8906 5.87077 25.9958 6.27184 26H25.7282C26.1292 25.9958 26.5222 25.8906 26.8679 25.6949C27.2135 25.4992 27.4999 25.2199 27.6986 24.8847C27.8972 24.5495 28.0011 24.1702 28 23.7843C27.9989 23.3985 27.8927 23.0197 27.6922 22.6856L17.964 7.06364C17.7593 6.73895 17.471 6.4705 17.1269 6.28419C16.7829 6.09788 16.3948 6 16 6C15.6052 6 15.2171 6.09788 14.8731 6.28419C14.529 6.4705 14.2407 6.73895 14.036 7.06364Z",
    stroke: "#FF9847",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangle);
export default __webpack_public_path__ + "static/media/alert-triangle.b30bb21e79eb1bb8ca5c721b11eaa152.svg";
export { ForwardRef as ReactComponent };